import { resetTempChannel } from '@/connection/helpers';
import { store } from '@/store/main';
import { overrideCurrentChannel } from '@/store/slices/user';

export default function resetLoader() {
  store.dispatch(overrideCurrentChannel());
  resetTempChannel();
}
